export const SUPPORTED_LOCALES = [
    { code: 'pt-BR', label: 'Português', short: 'PT' },
    { code: 'en', label: 'English', short: 'EN' },
    { code: 'es', label: 'Español', short: 'ES' }
] as const;

export type AppLocale = typeof SUPPORTED_LOCALES[number]['code'];

export const DEFAULT_LOCALE: AppLocale = 'pt-BR';
export const LOCALE_STORAGE_KEY = 'ebrigada.locale';

export function normalizeLocale(locale: string | null | undefined): AppLocale | null {
    const normalized = (locale || '').trim().replace('_', '-').toLowerCase();

    if (normalized === 'pt' || normalized === 'pt-br') return 'pt-BR';
    if (normalized === 'en' || normalized.startsWith('en-')) return 'en';
    if (normalized === 'es' || normalized.startsWith('es-')) return 'es';

    return null;
}

export function getPersistedLocale(): AppLocale {
    try {
        return normalizeLocale(window.localStorage.getItem(LOCALE_STORAGE_KEY)) || DEFAULT_LOCALE;
    } catch {
        return DEFAULT_LOCALE;
    }
}

export function persistLocale(locale: AppLocale): void {
    try {
        window.localStorage.setItem(LOCALE_STORAGE_KEY, locale);
    } catch {
        // Some restricted webviews can disable local storage.
    }
}
